module.exports = __webpack_public_path__ + "img/saizi4.9465db0f.png";